"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getElementExporter = exports.isElementWithChildren = exports.ELEMENTS_WITH_CHILDREN = exports.ELEMENT_TO_MARKDOWN = void 0;
const toMarkdown_1 = require("../elements/elements/Accordion/toMarkdown");
const toMarkdown_2 = require("../elements/elements/Audio/toMarkdown");
const toMarkdown_3 = require("../elements/elements/Button/toMarkdown");
const toMarkdown_4 = require("../elements/elements/Card/toMarkdown");
const toMarkdown_5 = require("../elements/elements/Chart/toMarkdown");
const toMarkdown_6 = require("../elements/elements/Checkbox/toMarkdown");
const toMarkdown_7 = require("../elements/elements/Code/toMarkdown");
const toMarkdown_8 = require("../elements/elements/CourseProgress/toMarkdown");
const toMarkdown_9 = require("../elements/elements/CourseStructure/toMarkdown");
const toMarkdown_10 = require("../elements/elements/Divider/toMarkdown");
const toMarkdown_11 = require("../elements/elements/Downloader/toMarkdown");
const toMarkdown_12 = require("../elements/elements/Embedded/toMarkdown");
const toMarkdown_13 = require("../elements/elements/Grouping/toMarkdown");
const toMarkdown_14 = require("../elements/elements/Image/toMarkdown");
const toMarkdown_15 = require("../elements/elements/LabeledGraphic/toMarkdown");
const toMarkdown_16 = require("../elements/elements/LayoutList/toMarkdown");
const toMarkdown_17 = require("../elements/elements/Link/toMarkdown");
const toMarkdown_18 = require("../elements/elements/List/toMarkdown");
const toMarkdown_19 = require("../elements/elements/Rectangle/toMarkdown");
const toMarkdown_20 = require("../elements/elements/Reflection/toMarkdown");
const toMarkdown_21 = require("../elements/elements/RichText/toMarkdown");
const toMarkdown_22 = require("../elements/elements/Simulator/toMarkdown");
const toMarkdown_23 = require("../elements/elements/Slider/toMarkdown");
const toMarkdown_24 = require("../elements/elements/Splitter/toMarkdown");
const toMarkdown_25 = require("../elements/elements/Table/toMarkdown");
const toMarkdown_26 = require("../elements/elements/Tabs/toMarkdown");
const toMarkdown_27 = require("../elements/elements/TestFeedback/toMarkdown");
const toMarkdown_28 = require("../elements/elements/TestGeneralFeedback/toMarkdown");
const toMarkdown_29 = require("../elements/elements/TestGrouping/toMarkdown");
const toMarkdown_30 = require("../elements/elements/TestHotspot/toMarkdown");
const toMarkdown_31 = require("../elements/elements/TestInfoEnd/toMarkdown");
const toMarkdown_32 = require("../elements/elements/TestInfoStart/toMarkdown");
const toMarkdown_33 = require("../elements/elements/TestKeyboardInput/toMarkdown");
const toMarkdown_34 = require("../elements/elements/TestMatching/toMarkdown");
const toMarkdown_35 = require("../elements/elements/TestMultipleChoice/toMarkdown");
const toMarkdown_36 = require("../elements/elements/TestRanking/toMarkdown");
const toMarkdown_37 = require("../elements/elements/TestResult/toMarkdown");
const toMarkdown_38 = require("../elements/elements/TestSingleChoice/toMarkdown");
const toMarkdown_39 = require("../elements/elements/Video/toMarkdown");
exports.ELEMENT_TO_MARKDOWN = {
    accordion: toMarkdown_1.toMarkdown,
    audio: toMarkdown_2.toMarkdown,
    button: toMarkdown_3.toMarkdown,
    card: toMarkdown_4.toMarkdown,
    chart: toMarkdown_5.toMarkdown,
    checkbox: toMarkdown_6.toMarkdown,
    code: toMarkdown_7.toMarkdown,
    courseProgress: toMarkdown_8.toMarkdown,
    courseStructure: toMarkdown_9.toMarkdown,
    divider: toMarkdown_10.toMarkdown,
    downloader: toMarkdown_11.toMarkdown,
    embedded: toMarkdown_12.toMarkdown,
    grouping: toMarkdown_13.toMarkdown,
    image: toMarkdown_14.toMarkdown,
    labeledGraphic: toMarkdown_15.toMarkdown,
    layoutList: toMarkdown_16.toMarkdown,
    link: toMarkdown_17.toMarkdown,
    list: toMarkdown_18.toMarkdown,
    rectangle: toMarkdown_19.toMarkdown,
    reflection: toMarkdown_20.toMarkdown,
    richText: toMarkdown_21.toMarkdown,
    simulator: toMarkdown_22.toMarkdown,
    slider: toMarkdown_23.toMarkdown,
    splitter: toMarkdown_24.toMarkdown,
    table: toMarkdown_25.toMarkdown,
    tabs: toMarkdown_26.toMarkdown,
    testFeedback: toMarkdown_27.toMarkdown,
    testGeneralFeedback: toMarkdown_28.toMarkdown,
    testGrouping: toMarkdown_29.toMarkdown,
    testHotspot: toMarkdown_30.toMarkdown,
    testInfoEnd: toMarkdown_31.toMarkdown,
    testInfoStart: toMarkdown_32.toMarkdown,
    testKeyboardInput: toMarkdown_33.toMarkdown,
    testMatching: toMarkdown_34.toMarkdown,
    testMultipleChoice: toMarkdown_35.toMarkdown,
    testRanking: toMarkdown_36.toMarkdown,
    testResult: toMarkdown_37.toMarkdown,
    testSingleChoice: toMarkdown_38.toMarkdown,
    video: toMarkdown_39.toMarkdown,
};
exports.ELEMENTS_WITH_CHILDREN = ['tabs', 'accordion', 'slider', 'layoutList'];
const isElementWithChildren = (type) => exports.ELEMENTS_WITH_CHILDREN.includes(type);
exports.isElementWithChildren = isElementWithChildren;
const getElementExporter = (type) => exports.ELEMENT_TO_MARKDOWN[type];
exports.getElementExporter = getElementExporter;
